import { getProgressBarValue } from "@/features/challenge/helperFunctions/getProgressBarValue";
import { Box, Flex, Progress, Skeleton, Text } from "@radix-ui/themes";
import React, { memo } from "react";
import DateObject from "react-date-object";
import { ProgressBarProps } from "./ProgressBar.types";
import useTimeLeft from "@/features/challenge/hooks/useTimeLeft";

const ProgressBar: React.FC<ProgressBarProps> = ({ startDate, endDate }) => {
  // Date Variables
  const createdInMilliseconds =
    startDate["seconds"] * 1000 + startDate["nanoseconds"] / 1000000;
  const endInMilliseconds =
    endDate["seconds"] * 1000 + endDate["nanoseconds"] / 1000000;

  // Date Objects
  const startDateFormated = new DateObject({
    date: new Date(createdInMilliseconds),
  });
  const endDateFormatted = new DateObject({
    date: new Date(endInMilliseconds),
  });

  const { timeLeft, loading } = useTimeLeft(endDate, startDate);

  return (
    <Box>
      <Flex justify="center" mb="1">
        <Skeleton loading={loading}>
          <Text size="2" color="gray">
            {timeLeft ? timeLeft : "Challenge ends in..."}
          </Text>
        </Skeleton>
      </Flex>
      <Progress
        value={getProgressBarValue(
          startDate ? startDate["seconds"] : undefined,
          endDate ? endDate["seconds"] : undefined
        )}
      />
      <Flex justify="between">
        <Text size="2" color="gray">
          {startDateFormated.format("DD.MM.YYYY")}
        </Text>
        <Text size="2" color="gray">
          {endDateFormatted.format("DD.MM.YYYY")}
        </Text>
      </Flex>
    </Box>
  );
};

export default memo(ProgressBar);
